import React, { useEffect, useState } from "react";
import { api } from "@/lib/auth";
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip, Bar, BarChart, CartesianGrid } from "recharts";

export default function Analytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then(r => setD(r.data)); }, []);
  if (!d) return <div className="p-4 sm:p-8 text-zinc-500">Loading…</div>;

  const tooltipStyle = { background: "#0a0a0a", border: "1px solid #262626", color: "#fff" };

  return (
    <div className="p-4 sm:p-8 max-w-[1400px]">
      <div className="eyebrow mb-2">Insights</div>
      <h1 className="font-display text-5xl uppercase mb-8">Analytics</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card-surface p-6">
          <div className="flex justify-between items-baseline mb-4">
            <div className="eyebrow">Revenue (last 12 months)</div>
            <div className="font-display text-3xl text-red-500">${d.total_revenue.toFixed(0)}</div>
          </div>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={d.revenue_by_month}>
              <CartesianGrid strokeDasharray="3 3" stroke="#1a1a1a" />
              <XAxis dataKey="month" stroke="#71717a" fontSize={10} />
              <YAxis stroke="#71717a" fontSize={10} />
              <Tooltip contentStyle={tooltipStyle} />
              <Bar dataKey="amount" fill="#DC2626" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="card-surface p-6">
          <div className="eyebrow mb-4">Registrations vs Inquiries</div>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={d.inquiries_by_month.map((r, i) => ({ month: r.month, inquiries: r.count, registrations: d.registrations_by_month[i].count }))}>
              <CartesianGrid strokeDasharray="3 3" stroke="#1a1a1a" />
              <XAxis dataKey="month" stroke="#71717a" fontSize={10} />
              <YAxis stroke="#71717a" fontSize={10} />
              <Tooltip contentStyle={tooltipStyle} />
              <Line type="monotone" dataKey="inquiries" stroke="#A1A1AA" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="registrations" stroke="#DC2626" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="card-surface p-6 md:col-span-2">
          <div className="eyebrow mb-4">Popular batches</div>
          {d.popular_batches.length === 0 && <div className="text-zinc-500">No registrations yet.</div>}
          <div className="space-y-2">
            {d.popular_batches.map(b => (
              <div key={b.batch} className="flex items-center gap-4">
                <div className="w-40 font-semibold">{b.batch}</div>
                <div className="flex-1 h-2 bg-white/5">
                  <div className="h-2 bg-red-600" style={{ width: `${Math.min(100, b.count * 10)}%` }}/>
                </div>
                <div className="w-12 text-right text-red-500 font-bold">{b.count}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
